import { Euler, Mesh, Object3D } from "three";

import { computeBoundingBoxHelper } from "../vessels/helpers/computeBoundingBoxHelper";

export class Holder3D {
  private _visible: boolean;

  private _objects3D: Record<string, Object3D | Mesh | Holder3D> = {};

  private _holder3D: Object3D;
  private _reCenter: Object3D;

  constructor(name: string) {
    this._visible = true;

    this._holder3D = new Object3D();
    this._reCenter = new Object3D();

    this._holder3D.name = name;
    this._holder3D.add(this._reCenter);

    this._reCenter.name = `${name}-reCenter`;
  }

  get type() {
    return "holder3d";
  }

  get visible() {
    return this._visible;
  }

  set visible(v) {
    this._visible = !!v;
    this._holder3D.visible = this._visible;
  }

  get holder3D() {
    return this._holder3D;
  }

  get positionX() {
    return this._holder3D.position.x;
  }

  set positionX(v) {
    this._holder3D.position.x = v;
  }

  get position() {
    return this._holder3D.position.clone();
  }

  set position(v: { x: number; y: number; z: number }) {
    this._holder3D.position.copy(v);
  }

  get scale() {
    return this._holder3D.scale.clone();
  }

  set scale(v: { x: number; y: number; z: number }) {
    this._holder3D.scale.copy(v);
  }

  get rotation() {
    return this._holder3D.rotation.clone();
  }

  set rotation(v: Euler) {
    this._holder3D.rotation.copy(v);
  }

  get uuid() {
    return this._holder3D.uuid;
  }

  add3D(name: string, obj3D: Object3D | Mesh | Holder3D) {
    if (name) this._objects3D[name] = obj3D;

    if (obj3D instanceof Holder3D) {
      this._reCenter.add(obj3D.holder3D);
    } else {
      obj3D.name = name;
      this._reCenter.add(obj3D);
    }
  }

  get3D(name: string) {
    return this._objects3D[name];
  }

  getObjectByName(name: string) {
    return this._reCenter.getObjectByName(name);
  }

  add(obj3D: Object3D) {
    this._reCenter.add(obj3D);
  }

  setChildVisible(name: string, visible: boolean) {
    const obj3D = this._objects3D[name];
    if (obj3D) obj3D.visible = visible;
  }

  recenterX = (nameOfRefPart?: string | false) => {
    const refPart = nameOfRefPart
      ? this._objects3D[nameOfRefPart]
      : this._holder3D;

    const boxFF = computeBoundingBoxHelper(refPart as Mesh);
    if (!boxFF) return;

    const minX = boxFF.box.min.x;
    this._reCenter.position.x = -minX;
  };
}
